import { FilterSearchingBaseViewModel, EnumSiNoTodos } from '../../../core/_infrastructure/types/common';

// *** Está en common.ts ***\\
// export class WBotanicaExtendedViewModel {

export class FilterSearchingWBotanicaExtendedViewModel extends FilterSearchingBaseViewModel {
    public IdGrupo: number | null = null;
    public IdForma: number | null = null;
    public IdSubForma: number | null = null;
    public CodigoEppo: string = '';
    public IdNombreCientificoDescripcion: string = '';
    public NombreComun: string = '';
    public Activo: number = EnumSiNoTodos.TODOS;
    public HabilitadoImportacion: number = EnumSiNoTodos.TODOS;
    public HabilitadoExportacion: number = EnumSiNoTodos.TODOS;
    public HabilitadoChina: number = EnumSiNoTodos.TODOS;
    public EphytoReinoUnido: number = EnumSiNoTodos.TODOS;
    public AplicaDocumentacion: number = EnumSiNoTodos.TODOS;
}
